/* eslint-disable no-unused-vars */
import { useContext, useState, useEffect } from "react";
import AccordionItem from "./AccordionItem";
import { ModelContext, SettingsContext } from "../context";
import { Button, Form, FormGroup, Modal, List, Icon } from "semantic-ui-react";
import Select from "react-select";
import axios from "axios";
import HotSpotInsctance from "./HotspotInstance";
import ModalPopup from "../Modal";

const initialAnnotationTypes = [
  { label: "Animation", value: "1" },
  { label: "Annotation", value: "0" },
];
const initialAnimationTypes = [
  { label: "back", value: "0" },
  { label: "forward", value: "1" },
  { label: "back-forvard", value: "2" },
];

function HotSpotList({
  header = "Annotation List",
  listType = 0,
  items,
}) {
  const {
    annotationList,
    animationAnnotationList,
    authenticationToken,
    deleteAnnotation,
  } = useContext(SettingsContext);
  const { drawHotSpot, position, setShowSpot } = useContext(ModelContext);
  const [modelViewer, setModelViewer] = useState();
  const [newPosition, setNewPosition] = useState(null);
  const hotspotItems =
    items || (listType === 1 ? animationAnnotationList : annotationList);

  useEffect(() => {
    let viewer = document.getElementById("modelViewer");
    setModelViewer(viewer);
  }, []);

  const updateAnnotation = (annotationInfo) => {
    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Hotspot güncelleniyor...",
      })
    );

    if (annotationInfo.updateAnnotation)
      annotationInfo.position = newPosition.toString();

    axios
      .post(
        process.env.REACT_APP_BACKEND_API + `annotation/save`,
        annotationInfo,
        {
          headers: {
            Authorization: authenticationToken,
          },
        }
      )
      .then(
        (res) => {
          document.dispatchEvent(
            new CustomEvent("update-editor-popup", {
              detail: "Hotspot Güncellendi.",
            })
          );

          setNewPosition(null);
          document.dispatchEvent(
            new CustomEvent("close-editor-popup", { detail: "" })
          );
        },

        (rej) => {
          document.dispatchEvent(
            new CustomEvent("close-editor-popup", {
              detail: "Hotspot Güncellenemedi.",
            })
          );
        }
      );
  };

  const handleDeleteAnnotation = (annotation) => {
    if (!annotation?.id) return;
    if (!window.confirm("Hotspot silinsin mi?")) return;

    document.dispatchEvent(
      new CustomEvent("open-editor-popup", {
        detail: "Hotspot siliniyor...",
      })
    );

    deleteAnnotation(annotation.id).then(
      () => {
        document.dispatchEvent(
          new CustomEvent("update-editor-popup", {
            detail: "Hotspot silindi.",
          })
        );
        document.dispatchEvent(
          new CustomEvent("close-editor-popup", { detail: "" })
        );
      },
      () => {
        document.dispatchEvent(
          new CustomEvent("close-editor-popup", {
            detail: "Hotspot silinemedi.",
          })
        );
      }
    );
  };

  const handleHotSpot = async (annotation) => {
    setShowSpot(true);
    annotation.updateAnnotation = true;

    //setUpdateHotSpotPosition(true);
    let scene = modelViewer.scene();
    HotSpotInsctance.bind(modelViewer, scene, true);
    modelViewer.addEventListener("click", updateAnnotationPosition);
  };

  const updateAnnotationPosition = (annotation) => {
    drawHotSpot();
    const { position, normal } = HotSpotInsctance.points();
    setNewPosition(position);
    modelViewer.removeEventListener("click", updateAnnotationPosition);
  };

  return (
    <div>
      <AccordionItem header={header}>
        <div className="accordion">
          <div style={{ width: "100%" }}>
            <List>
              {hotspotItems?.map((annotation, index) => {
                return (
                  <AccordionItem
                    header={
                      annotation?.header ||
                      annotation?.animationName ||
                      `Hotspot ${index + 1}`
                    }
                    key={annotation?.id || index}
                  >
                    <Form>
                      <Form.Group widths="equal">
                        <Form.Input
                          label="Animation Name"
                          onChange={(e) => {
                            annotation.animationName = e.target.value;
                          }}
                          defaultValue={annotation?.animationName}
                        />
                      </Form.Group>

                      <Form.Group widths="equal">
                        <Form.Input
                          label="Annotation Header"
                          onChange={(e) => {
                            annotation.header = e.target.value;
                          }}
                          defaultValue={annotation?.header}
                        />
                        <Form.Input
                          label="Annotation Text"
                          onChange={(e) => {
                            annotation.text = e.target.value;
                          }}
                          defaultValue={annotation?.text}
                        />
                      </Form.Group>

                      <FormGroup widths="equal">
                        <button
                          className="saveButton"
                          type="button"
                          onClick={() => {
                            handleHotSpot(annotation);
                          }}
                          style={{ float: "left" }}
                        >
                          <Icon name="dot circle outline" />
                          Update Hotspot
                        </button>
                      </FormGroup>

                      <Form.Input
                        label="new Position"
                        defaultValue={newPosition}
                      />
                      <Form.Group>
                        <button
                          className="saveButton"
                          type="button"
                          onClick={() => {
                            updateAnnotation(annotation);
                          }}
                        >
                          Update
                        </button>
                        <button
                          className="saveButton"
                          type="button"
                          style={{ marginLeft: "8px", backgroundColor: "#d9534f" }}
                          onClick={() => {
                            handleDeleteAnnotation(annotation);
                          }}
                        >
                          <Icon name="trash" />
                          Delete
                        </button>
                      </Form.Group>
                    </Form>
                  </AccordionItem>
                );
              })}
            </List>
          </div>
        </div>
        <br />
      </AccordionItem>
    </div>
  );
}
export default HotSpotList;
